import React from 'react';
import {Layout} from 'antd';
import classNames from 'classnames';
import './index.less';

const BaseContent = ({children, className = ''}) => {
  const Cls = classNames('baseContent', className);
  return <Layout className={Cls}>{children}</Layout>;
};

export default BaseContent;
